
import LoanrepaymentMainComp from "../../components/loan-repayment/LoanrepaymentMainComp"

export const LoanreypaymentReportsPages = ({ title_1, title_2, title }) => {
   
    return <div>
        <LoanrepaymentMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}